// extracted by mini-css-extract-plugin
export default {"flavor_option":"QW","out_of_stock_text":"RW","out_of_stock":"SW","flavor_option_image":"TW","flavor_option_info":"UW","flavor_option_title":"VW","flavor_option_limited":"WW","flavor_option_amount_wrapper":"XW","flavor_option_amount_button":"YW","zero_amount":"ZW","no_flavors":"aX","no_flavors_active":"bX","flavor_option_select_wrapper":"cX","flavor_option_select_wrapper__selected":"eX"};
    if(module.hot) {
      // 1713361654151
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  